var labelI18n = {
  countRemainingA11y: '%current of %total characters remaining',
  countUsedA11y: '%current characters used',
  countRemaining: '%current / %total',
  countUsed: 'characters: %current'
};
export default labelI18n;